// Shopify prefixes section wrapper ids with the template name
// (e.g. "shopify-section-template--123__how_it_works"), so match on a
// substring of the id rather than an exact id.
const SELECTOR =
  '.shopify-section[id*="how_it_works"] .layout-panel-flex--row, .shopify-section[id*="six_reasons"] .layout-panel-flex--row';

/**
 * @param {HTMLElement} row
 */
function setupDots(row) {
  const slides = Array.from(row.children).filter((el) => el instanceof HTMLElement);
  if (slides.length <= 1 || row.nextElementSibling?.classList?.contains('mobile-carousel-dots')) return;

  const nav = document.createElement('div');
  nav.className = 'mobile-carousel-dots';
  nav.setAttribute('role', 'tablist');

  const dots = slides.map((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'mobile-carousel-dots__dot';
    dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
    dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
    dot.addEventListener('click', () => {
      row.scrollTo({ left: slides[index].offsetLeft - row.offsetLeft, behavior: 'smooth' });
    });
    nav.appendChild(dot);
    return dot;
  });

  row.insertAdjacentElement('afterend', nav);

  let ticking = false;
  row.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const activeIndex = Math.round(row.scrollLeft / row.clientWidth);
        dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        ticking = false;
      });
    },
    { passive: true }
  );
}

function init() {
  document.querySelectorAll(SELECTOR).forEach((row) => {
    if (row instanceof HTMLElement) setupDots(row);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
